import { Area, DeviceEnabledTypeProps, TurfUtils, UserAttributeDefs } from '@iotv/datamodel-core';

const { convertPointToTurfPosition, getThingInArea } = TurfUtils;

const debug = !process.env.AWS_SESSION_TOKEN && false;

const typeName = 'Field';

class Field extends Area {
  constructor(ob: DeviceEnabledTypeProps) {
    super({ ...ob, type: typeName });
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of the Zone eg south field',
      },
      functions: {
        type: 'Derived',
        valueFn: (state: any, functions: { [k: string]: Function }, accessKey: string) => {
          return { state, functions, accessKey, thisObject: this };
        },
        viewName: 'UIThingFunctions',
      },

      Location: {
        type: 'Derived',
        valueFn: (state: any, functions: { [k: string]: Function }) => {
          const pointArr = convertPointToTurfPosition?.(this.position);
          const field = state.userView ? getThingInArea?.(state.userView, pointArr) : undefined;
          return {
            thing: this,
            position: this.position,
            field,
          };
        },
        viewName: 'FieldDetails',
      },

      History_Charts: {
        type: 'Derived',
        actions: {
          create: false,
          link: false,
        },
        valueFn: () => {
          return { currentThingHistory: this.history };
        },
        viewName: 'ThingHistoryCharts',
      },

      Device: {
        type: 'Array',
        label: 'Monitoring Devices',
        cardinality: {
          out: null,
          in: 1,
        },
      },
    };
  }

  getLinkAttributes() {
    const functions = this.getUserAttributes().functions;
    return {
      ...super.getLinkAttributes(),
      functions,
    };
  }
}

export { Field };
